import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'CHECK_IN_OUT_RULESET' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/check-in-out-ruleset/handlers.js